import gql from 'graphql-tag'

export default gql`
  mutation deleteAuthor($id: Int!) {
    deleteAuthor(id: $id) {
      id
    }
  }
`


// WEBPACK FOOTER //
// ./src/apollo/graphql/author/delete.js